import React from 'react';
import { Layout } from '../components/Layout';

export function Cookies() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Cookie Policy</h1>
        <div className="prose prose-lg max-w-none space-y-6">
          <p className="text-gray-600 text-sm">Last Updated: December 1, 2024</p>
          
          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. What Are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. How We Use Cookies</h2>
            
            <h3 className="text-xl font-semibold mt-6 mb-3">Essential Cookies (Required)</h3>
            <p>These cookies are necessary for the Service to function:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Authentication:</strong> Keeps you logged in</li>
              <li><strong>Security:</strong> Protects against fraud and abuse</li>
              <li><strong>Session Management:</strong> Maintains your active session</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">Functional Cookies</h3>
            <p>These cookies enhance functionality:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Preferences:</strong> Remembers your settings and choices</li>
              <li><strong>Language:</strong> Stores your language preference</li>
              <li><strong>UI State:</strong> Saves your interface customizations</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">Analytics Cookies</h3>
            <p>These cookies help us understand usage patterns:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Performance:</strong> Tracks page load times and errors</li>
              <li><strong>Usage Statistics:</strong> Helps us improve features</li>
              <li><strong>Anonymous Analytics:</strong> Aggregated, non-personal data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. Third-Party Cookies</h2>
            <p>We may use third-party services that set their own cookies:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Stripe:</strong> For secure payment processing</li>
              <li><strong>Google Analytics:</strong> For website analytics (if enabled)</li>
            </ul>
            <p className="mt-4">
              These third parties have their own cookie policies. We recommend reviewing them:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Stripe Cookie Policy: <a href="https://stripe.com/cookies-policy/legal" className="text-purple-600 hover:underline" target="_blank" rel="noopener noreferrer">stripe.com/cookies-policy</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Managing Cookies</h2>
            
            <h3 className="text-xl font-semibold mt-6 mb-3">Browser Settings</h3>
            <p>You can control cookies through your browser settings:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies</li>
              <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies</li>
              <li><strong>Edge:</strong> Settings → Cookies and Site Permissions</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">Impact of Disabling Cookies</h3>
            <p>
              <strong>Note:</strong> Disabling essential cookies may prevent you from using certain features of our Service, including logging in and saving your work.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Cookie Duration</h2>
            <p>We use two types of cookies based on duration:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Session Cookies:</strong> Deleted when you close your browser</li>
              <li><strong>Persistent Cookies:</strong> Remain on your device for a set period (typically 30-365 days) or until you delete them</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">6. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time. Changes will be posted on this page with an updated revision date.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">7. Contact Us</h2>
            <p>
              For questions about our use of cookies:<br />
              <strong>Email:</strong> privacy@upost.com
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}
